// extracted by mini-css-extract-plugin
export default {"title":"title___Wlmq1","link":"link___LvpAA"};